import {
  ButtonItem,
  CustomRule,
  Form,
  FormRef,
  Item,
  Label,
  RequiredRule,
} from "devextreme-react/form";
import { Popup } from "devextreme-react/popup";
import notify from "../../lib/notify";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { changePassword } from "../../api/auth";
import { useAuth } from "../../contexts/auth";
import "./ChangePassword.scss";

export const ChangePassword = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const formRef = useRef<FormRef | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [peselNumber, setPeselNumber] = useState<string>("");

  const handlePopup = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const handleChangePassword = async () => {
    const validationResult = formRef.current?.instance().validate();
    if (validationResult?.isValid) {
      if (newPassword !== confirmPassword) {
        alert(t("Passwords do not match"));
      } else {
        setIsLoading(true);

        const response = await changePassword(newPassword, peselNumber);
        if (response.isOk) {
          notify(t("Password changes succesfull."), "success");
          setIsModalVisible(false);
        } else {
          setIsModalVisible(false);
          notify(
            `${t("Error:")} ${response.error || t("Unknown error")}`,
            "error"
          );
        }

        setIsLoading(false);
      }
    }
  };

  return (
    <div className="change-password">
      <h1>{t("Change password")}</h1>
      <p>
        {t(
          "This page allows you to easily update your account password. If you want to enhance your account security or only change current password, you can do it here."
        )}
      </p>
      <button className="change-password-button" onClick={handlePopup}>
        {t("Change")}
      </button>

      <Popup
        visible={isModalVisible}
        onHiding={handleCloseModal}
        maxWidth={400}
        height="auto"
        maxHeight="80vh"
        title={t("Change your password")}
        showCloseButton
        dragEnabled
      >
        <Form ref={formRef}>
          <Item
            editorType="dxTextBox"
            editorOptions={{
              value: newPassword,
              onValueChanged: (e: any) => setNewPassword(e.value),
              mode: "password",
            }}
          >
            <RequiredRule message={t("New password is required")} />
            <Label text={t("New password")} />
          </Item>
          <Item
            dataField="confirmPassword"
            editorType="dxTextBox"
            editorOptions={{
              value: confirmPassword,
              onValueChanged: (e: any) => setConfirmPassword(e.value),
              mode: "password",
            }}
          >
            <RequiredRule message={t("Password confirmation is required")} />
            <CustomRule
              message={t("Passwords do not match")}
              validationCallback={() => newPassword === confirmPassword}
            />
            <Label text={t("Confirm new password")} />
          </Item>
          <Item
            dataField="peselNumber"
            editorType="dxTextBox"
            editorOptions={{
              value: peselNumber,
              onValueChanged: (e: any) => setPeselNumber(e.value),
            }}
          >
            <RequiredRule message={t("PESEL number is required")} />
            <Label text={t("PESEL")} />
          </Item>
          <ButtonItem
            buttonOptions={{
              text: t("Send"),
              type: "default",
              onClick: handleChangePassword,
              disabled: isLoading,
            }}
          />
        </Form>
      </Popup>
    </div>
  );
};
